<div class="pitchers" *ngIf="pitchers?.length; else empty">
  <h3 class="pitchers__title">Pitching</h3>
  <ul class="pitchers__list">
    <li *ngFor="let p of pitchers" class="pitchers__item">
      <div class="pitchers__name-row">
        <span class="pitchers__num">{{ utilService.getNumber(p, broadcast) }}</span>
        <span class="pitchers__name">{{ p.name }}</span>
      </div>
      <div class="pitchers__stats">
        <div class="pitchers__stat"><span>IP</span><strong>{{ p.gameStats?.pitching?.ip ?? '-' }}</strong></div>
        <div class="pitchers__stat"><span>P/S</span><strong>{{ p.gameStats?.pitching?.pitches ?? 0 }}/{{ p.gameStats?.pitching?.strikes ?? 0 }}</strong></div>
        <div class="pitchers__stat"><span>H</span><strong>{{ p.gameStats?.pitching?.h ?? 0 }}</strong></div>
        <div class="pitchers__stat"><span>K</span><strong>{{ p.gameStats?.pitching?.k ?? 0 }}</strong></div>
        <div class="pitchers__stat"><span>BB</span><strong>{{ p.gameStats?.pitching?.bb ?? 0 }}</strong></div>
        <div class="pitchers__stat"><span>ER/RA</span><strong>{{ p.gameStats?.pitching?.er ?? 0 }}/{{ p.gameStats?.pitching?.ra ?? 0 }}</strong></div>
      </div>
    </li>
  </ul>
</div>

<ng-template #empty>
  <div class="pitchers__empty">No pitching data yet.</div>
</ng-template>
